import { render, staticRenderFns } from "./searchPanel.vue?vue&type=template&id=5686fc4d&scoped=true&"
import script from "./searchPanel.vue?vue&type=script&lang=js&"
export * from "./searchPanel.vue?vue&type=script&lang=js&"
import style0 from "./searchPanel.vue?vue&type=style&index=0&id=5686fc4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5686fc4d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextSearch: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/filters/textSearch.vue').default,UserLocation: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/filters/userLocation.vue').default})
